/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils
import { isLight } from 'utils/theme'

// TODO: Move this to utils file
const typefaceOptions = {
  DECORATIVE_AND_PLAIN: {
    SYSTEM: {
      header: 'serif',
      body: 'sans-serif'
    },
    HIGH_FIDELITY: {
      header: '"Source Serif Pro",Georgia, serif',
      body: '"Work Sans", Verdana, sans-serif'
    }
  },
  DECORATIVE: {
    SYSTEM: {
      header: 'serif',
      body: 'serif'
    },
    HIGH_FIDELITY: {
      header: '"Source Serif Pro",Georgia, serif',
      body: '"Source Serif Pro",Georgia, serif',
    }
  },
  PLAIN: {
    SYSTEM: {
      header: 'sans-serif',
      body: 'sans-serif'
    },
    HIGH_FIDELITY: {
      header: '"Work Sans", Verdana, sans-serif',
      body: '"Work Sans", Verdana, sans-serif'
    }
  },
}

const titleSizeOption = {
  SMALL: '12px',
  MEDIUM: '14px',
  LARGE: '16px'
}

const headerSizeOptions = {
  SMALL: '16px',
  MEDIUM: '18px',
  LARGE: '20px'
}

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION SITE THEME SECTION - THEME PREVIEW : STYLES --------------- ++++++++++ */
export default theme => ({
  themepreview: {
    '& .previewconfig': {
      '& .content': {
        background: props => props.siteTheme.customBackgroundColor || '#FFF',
        color: props => isLight(props.siteTheme.customBackgroundColor) ? '#000000' : '#FFFFFF',
        '& > div': {
          maxWidth: pxToEm(450),
        }
      }
    },
   '& .emojicontainer': {
      background: ({ themeColors }) => themeColors['backgroundPrimary'],
    },
    '&.isemojimonochrome-true': {
      '& svg, & rect, & path': {
        fill: ({ themeColors }) => themeColors['primary']
      }
    },
    '& h3': {
      color: ({ themeColors }) => themeColors['neutrals.bodyText'],
      fontFamily: ({ siteTheme }) => typefaceOptions[siteTheme.fontTypeface][siteTheme.useSystemFont ? 'SYSTEM' : 'HIGH_FIDELITY'].header || 'serif',
      fontSize: ({ siteTheme }) => headerSizeOptions[siteTheme.fontSize] || '18px',
      fontWeight: 600
    },
    '& p, & .titlewrap, & span': {
      fontFamily: ({ siteTheme }) => typefaceOptions[siteTheme.fontTypeface][siteTheme.useSystemFont ? 'SYSTEM' : 'HIGH_FIDELITY'].body || 'sans-serif',
      fontSize: ({ siteTheme }) => titleSizeOption[siteTheme.fontSize] || '14px',
      fontWeight: 400
    },
    '& .emoji': {
      borderRadius: pxToEm(8),
      '&.active-true': {
        background: ({ themeColors }) => themeColors['backgroundSecondary'],
      }
    }
  }
});
